import { CustomerOrdersResponse } from "@omni/types/api/cart/bff/customerOrders.response";
import { isDefined } from "@omni/utils/helper.utils";
import { useEffect, useState } from "react";

import { createApiFor } from "@/api/hooks/utils";
import { Config } from "@/utils/config.utils";

export const CUSTOMER_ORDER_LIST_PAGE_SIZE = 10;

const cartServiceApi = createApiFor(`/${Config.general.basestore}`, {
    bff: true
});

const fetchOrders = (currentPage: number, page: number) =>
    cartServiceApi
        .get<CustomerOrdersResponse>("/orders/customer", {
            params: {
                page: page - 1,
                pageSize: (page - currentPage) * CUSTOMER_ORDER_LIST_PAGE_SIZE
            }
        })
        .then(({ data }) => data);

const defaultCustomerOrderList: CustomerOrdersResponse = {
    orders: [],
    errors: [],
    pageSize: CUSTOMER_ORDER_LIST_PAGE_SIZE,
    totalPages: 0,
    warnings: [],
    totalElements: 0,
    currentPage: 0
};

export const useOrderList = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [customerOrderList, setCustomerOrderList] = useState<
        CustomerOrdersResponse | undefined
    >(undefined);

    const loadOrderList = async (page: number) => {
        setLoading(true);

        const fetchedCustomerOrderList = await fetchOrders(
            customerOrderList?.currentPage ?? 0,
            page
        );

        setCustomerOrderList((currentCustomerOrderList) => ({
            orders: [
                ...(currentCustomerOrderList?.orders ?? []),
                ...fetchedCustomerOrderList.orders
            ],
            currentPage: page,
            totalElements: fetchedCustomerOrderList.totalElements,
            errors: fetchedCustomerOrderList.errors ?? [],
            pageSize:
                fetchedCustomerOrderList.pageSize ??
                CUSTOMER_ORDER_LIST_PAGE_SIZE,
            totalPages: fetchedCustomerOrderList.totalPages ?? 0,
            warnings: fetchedCustomerOrderList.warnings ?? []
        }));
        setLoading(false);
    };

    const loadNextPage = () =>
        loadOrderList((customerOrderList?.currentPage ?? 0) + 1);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (isDefined(customerOrderList)) return;

        loadNextPage();
    }, [customerOrderList]);

    return {
        customerOrderList: customerOrderList ?? defaultCustomerOrderList,
        loading: loading,
        loadNextPage: loadNextPage
    };
};
